/**
 * Development-only test user configuration
 * These are only used in development mode for quick user switching
 *
 * Passwords have been removed — dev sign-in is now passwordless
 * via the dev-sign-in edge function.
 */

export interface DevUser {
  email: string;
  label: string;
}

export const DEV_USERS: DevUser[] = [
  { email: "superadmin@test.com", label: "Super-Admin" },
  { email: "admin@test.com", label: "Admin" },
  // TES-1886: qm_admin ist die 5. kanonische v2.3-Rolle (role_id-only). Der dedizierte Test-User
  // qmadmin@test.com wird von DATAFIX_032 (seed-group-centric) geseedet.
  { email: "qmadmin@test.com", label: "QM-Admin" },
  { email: "qm@test.com", label: "Qualitätsmanager" },
  { email: "mangel@test.com", label: "Mangelbearbeiter" },
  { email: "tester@test.com", label: "Tester" },
  // TES-2617: customer_approver ist die 5. Rolle des Owner-Durchtests (KLICKTHROUGH §5) und war ohne
  // Quick-Login-Knopf nicht erreichbar. customer@test.com wird vom kanonischen Seed seed-dev-users
  // bereits mit role: "customer_approver" angelegt — der Knopf wirkt erst nach einem Seed-Lauf.
  { email: "customer@test.com", label: "Kundenabnahme" },
  // TES-2056: AT/Indien-Testuser (DATAFIX_034) — Multi-Standort-Fixtures für dynamische Gruppen
  // (profiles.job_title/department/standort gesetzt; Rollen je Standort: QM/tester/mangelbearbeiter).
  { email: "qm-linz@test.com", label: "QM Linz" },
  { email: "qmstv-linz@test.com", label: "QM-Stv. Linz" },
  { email: "endmontage-linz@test.com", label: "Endmontage Linz" },
  { email: "vormontage-linz@test.com", label: "Vormontage Linz" },
  { email: "qm-indien@test.com", label: "QM Indien" },
  { email: "lackierung-indien@test.com", label: "Lackierung Indien" },
  { email: "produktion-indien@test.com", label: "Produktion Indien" },
  { email: "schweisserei-indien@test.com", label: "Schweißerei Indien" },
];
